import React, { useEffect, useState } from 'react';

import { useUnleashContext } from '@unleash/proxy-client-react';

interface IUserSessionProps {
  userId: string;
}

const UserSession: React.FC<IUserSessionProps> = ({ userId }) => {
  const [alreadyUpdatedContext, setAlreadyUpdatedContext] = useState(false);
  const updateContext = useUnleashContext();

  useEffect(() => {
    try {
      if (userId !== '' && !alreadyUpdatedContext) {
        // context is updated with userId
        updateContext({ userId });
        setAlreadyUpdatedContext(true);
      }
    } catch (err) {
      console.error('Erro ao atualizar userId para flags: ' + err);
    }
  }, [updateContext, alreadyUpdatedContext, userId]);

  return <></>;
};

export default UserSession;
